export const jobWorkplaceTypesEn = {
  jobWorkplaceTypes: {
    any: 'Does not matter',
    office: 'Office',
    home: 'Remote',
    mix: 'Hybrid',
    travel: 'With travel',
  },
};
